import { COLORS } from 'helpers/globals'

const button = {
  padding: '.3rem 1rem',
  borderRadius: '1rem',
  color: 'white',
  fontWeight: 400,
  cursor: 'pointer',
  '&.mobile': { padding: '.4rem 1rem' }
}

const buttonWrapper = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  fontSize: '1.2rem'
}

export default {
  wiringPanel: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  buttonWrapper,
  mobileButtonWrapper: {
    ...buttonWrapper,
    fontSize: '1.4rem'
  },
  cancelButton: {
    ...button,
    marginTop: '.5rem',
    background: 'red',
    '&:hover': { background: '#E60000' }
  },
  drawWireButton: {
    ...button,
    background: COLORS.primary,
    '&:hover': { background: '#2972B1' }
  },
  addNetworkClosetButton: {
    ...button,
    background: COLORS.green,
    '&:hover': { background: '#007800' }
  }
}



// WEBPACK FOOTER //
// ./src/components/WiringPanel/style.js